import PropTypes from 'prop-types';
import { motion, AnimatePresence } from 'framer-motion';

// Shared dialog wrapper used by every create/edit form across the org app.
// Despite the historical name, it renders as a CENTERED MODAL (not a side
// drawer) — matching the New product / New transfer dialogs. Callers supply the
// full panel body: a `shrink-0` header, a `flex-1 overflow-y-auto` content
// region, and a `shrink-0` footer, which lay out against the flex column here.
export const SideDrawer = ({ children, maxWidth = 'max-w-lg' }) => (
  <AnimatePresence>
    <motion.div
      initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
      className="fixed inset-0 z-[120] flex items-center justify-center p-4"
      style={{ background: 'rgba(15,23,42,0.5)', backdropFilter: 'blur(6px)' }}
    >
      <motion.div
        initial={{ opacity: 0, y: 16, scale: 0.98 }}
        animate={{ opacity: 1, y: 0, scale: 1 }}
        exit={{ opacity: 0, y: 8, scale: 0.98 }}
        transition={{ duration: 0.18 }}
        className={`w-full ${maxWidth} bg-white rounded-3xl shadow-2xl border border-[var(--theme-tertiary)] overflow-hidden flex flex-col`}
        style={{ maxHeight: '92vh' }}
      >
        {children}
      </motion.div>
    </motion.div>
  </AnimatePresence>
);

SideDrawer.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node,
  maxWidth: PropTypes.string,
};
